<div class="card box-shadow" [class.reduced]="reduced">
    <div class="card-body ta-c">
        <div class="mt-4 mb-4">
            <h3 class="font-weight-semi-bold">
                {{ 'components.defaultValues.noResultsToSearch' | translate }}
            </h3>
        </div>
    </div>
</div>
